import lonely from './assets/lonely.png';
import tumblrLogo from './assets/i_tumblr_desktop.svg';
import discordLogo from './assets/discord.svg';

export function StandardHeader()
{
    const discord = "https://discord.gg/Qx6sBpdw73";
    const tumblr = "https://www.tumblr.com/animitaproject";

    return (
      <div className="flex flex-col justify-center items-center mt-12 md:mt-32 lg:mt-16 xl:mt-24 2xl:mt-16">
        <img src={lonely} className="App-logo w-2/5 md:w-1/3 lg:w-auto h-auto lg:h-96" alt="logo" style={{animationIterationCount: 1}} />

        <div className="flex mt-8 md:mt-12 lg:mt-12">
          <a href={tumblr} target="_blank" rel="noopener noreferrer">
              <img src={tumblrLogo} alt="Tumblr Logo" className="h-12 w-12 m-2" />
          </a>
          <a href={discord} target="_blank" rel="noopener noreferrer">
              <img src={discordLogo} alt="Tumblr Logo" className="h-12 w-12 m-2" />
          </a>
        </div>

      </div>
    );
}